import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let OfficialDocumentFields = {
    'file_number': {
        display: {
            name: '公文檔號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'file_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'receive_number': {
        display: {
            name: '收文字號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'receive_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'send_number': {
        display: {
            name: '發文字號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'send_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'receive_date': {
        display: {
            name: '收文日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'receive_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'send_date': {
        display: {
            name: '發文日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'send_date',
            data_type: 'datetime',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'receive_org': {
        display: {
            name: '收文單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'receive_org',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'send_org': {
        display: {
            name: '發文單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'send_org',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    }
}

let OfficialDocument = (front_back) => {

    let fields = 
    [
        OfficialDocumentFields['file_number'],
        OfficialDocumentFields['receive_number'],
        OfficialDocumentFields['send_number'],
        OfficialDocumentFields['receive_date'],
        OfficialDocumentFields['send_date'],
        OfficialDocumentFields['receive_org'],
        OfficialDocumentFields['send_org'],   
    ]

    return {
        name: '公文資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    let candidates = [].concat(
        Basic('official_document', front_back),
        ForestryData('official_document', front_back),
        OfficialDocument(front_back), 
        Rights('official_document', front_back), 
        PhysicalObject('official_document', front_back))

    let fields = candidates.filter( x => x.fields.length > 0)

    return {
        name: '公文類',
        type: 'group',
        fields
    }
}

  